import type { PlaygroundDataProvider } from './provider-types'
import {
  addCityClerkComment,
  addCommentReply,
  getCommentReplies,
  getDocumentComments,
  getDocumentMeasurements,
  getDocumentOverlays,
  getDocumentScaleConfig,
  getImplicitAIComments,
  getPlaygroundSourceDocumentsByPermitSubmittalId,
  getSitePlanKeynotesMatching,
} from '../api/playground-api'
import { getMapOverlayGeoTransform } from '../api/map-overlay-api'
import {
  getAltaVsTitleCheckSummary,
  getAltaVsTitleReportByAttachmentId,
  getAltaVsTitleResult,
  renderAltaTitleDocx,
} from '../api/alta-vs-title-api'

export const backendPlaygroundProvider: PlaygroundDataProvider = {
  capabilities: {
    sourceDocuments: true,
    aiComments: true,
    aiOverlays: true,
    keynotesMatching: true,
    mapOverlay: true,
    cloudComments: true,
    localComments: false,
    altaVsTitle: true,
  },
  getSourceDocuments: getPlaygroundSourceDocumentsByPermitSubmittalId,
  getDocumentScaleConfig,
  getDocumentOverlays,
  getDocumentComments,
  getImplicitAIComments,
  getCommentReplies,
  addCommentReply,
  addCityClerkComment,
  getDocumentMeasurements,
  getSitePlanKeynotesMatching,
  getMapOverlayGeoTransform,
  getAltaVsTitleCheckSummary,
  getAltaVsTitleReportByAttachmentId,
  getAltaVsTitleResult,
  renderAltaTitleDocx,
}
